import React, { useState } from 'react';

const SearchEngineResultRow = ({ result, token, showToast }) => {
  const [reactions, setReactions] = useState([]);
  const reactionEmojis = ['\uD83D\uDC4D', '\uD83D\uDC4E', '\u2764\uFE0F', '\uD83D\uDD25', '\uD83D\uDCA1', '\u2B50', '\uD83D\uDCCC', '\uD83C\uDFAF'];

  const addReaction = async (emoji) => {
    setReactions(prev => {
      const exists = prev.find(r => r.emoji === emoji);
      if (exists) return prev.filter(r => r.emoji !== emoji);
      return [...prev, { emoji, count: 1 }];
    });
  };

  return (
    <div style={{
      display: 'flex', alignItems: 'flex-start', gap: 10, padding: '6px 8px',
      borderRadius: 6, background: 'rgba(253, 251, 247, 0.4)',
      border: '1px solid rgba(6, 182, 212, 0.1)',
      transition: 'all 0.15s'
    }}>
      {/* Title - Clickable */}
      <div style={{ flex: 1, minWidth: 0 }}>
        <a
          href={result.url}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: '#22d3ee',
            fontSize: '0.78rem',
            fontWeight: 600,
            textDecoration: 'none',
            display: 'block',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
          }}
          title={result.title || result.url}
        >
          {result.title || result.url}
        </a>
        
        {/* Snippet Preview (1-2 lines) */}
        {result.snippet && (
          <div style={{
            color: '#a1a1aa',
            fontSize: '0.68rem',
            marginTop: 2,
            lineHeight: 1.4,
            overflow: 'hidden',
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical'
          }}>
            {result.snippet}
          </div>
        )}
        
        {/* Article Type Tag */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginTop: 3 }}>
          {result.article_type && (
            <span style={{
              fontSize: '0.6rem',
              padding: '1px 6px',
              borderRadius: 4,
              background: 'rgba(253, 224, 71, 0.15)',
              color: '#047857'
            }}>
              {result.article_type}
            </span>
          )}
          
          {/* Domain */}
          <span style={{
            fontSize: '0.58rem',
            color: '#71717a',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            maxWidth: 150
          }}>
            {result.root_domain || new URL(result.url).hostname}
          </span>
        </div>
        
        {/* Quick Reaction Buttons */}
        <div style={{ display: 'flex', gap: 2, marginTop: 3 }}>
          {reactionEmojis.slice(0, 5).map(emoji => (
            <button
              key={emoji}
              onClick={() => addReaction(emoji)}
              style={{
                background: reactions.find(r => r.emoji === emoji) ? 'rgba(253, 224, 71,0.3)' : 'transparent',
                border: 'none',
                cursor: 'pointer',
                fontSize: '0.65rem',
                padding: '1px 3px',
                borderRadius: 3,
                opacity: 0.7
              }}
              title={`React with ${emoji}`}
            >
              {emoji}
            </button>
          ))}
        </div>
        
        {/* Reaction Count */}
        {reactions.length > 0 && (
          <div style={{ display: 'flex', gap: 4, marginTop: 2 }}>
            {reactions.map(r => (
              <span key={r.emoji} style={{ fontSize: '0.6rem', background: 'rgba(253, 224, 71,0.2)', padding: '1px 4px', borderRadius: 4 }}>
                {r.emoji} {r.count}
              </span>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

const SearchEngineResultsPanel = ({ searchEngineResults, setSearchEngineResults, token, showToast }) => {
  if (searchEngineResults.length === 0) return null;

  return (
    <div style={{
      background: 'linear-gradient(135deg, rgba(6, 182, 212, 0.1), rgba(20, 184, 166, 0.1))',
      borderRadius: 12,
      padding: 15,
      marginBottom: 15,
      border: '1px solid rgba(6, 182, 212, 0.3)'
    }} data-testid="search-engine-results">
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: 12
      }}>
        <h4 style={{ 
          color: '#22d3ee', 
          margin: 0, 
          fontSize: '0.95rem',
          display: 'flex',
          alignItems: 'center',
          gap: 8
        }}>
          Search Engine Results ({searchEngineResults.length})
          <span style={{ fontSize: '0.7rem', color: '#71717a' }}>
            Direct from search engines
          </span>
        </h4>
        <button
          onClick={() => setSearchEngineResults([])}
          style={{
            background: 'rgba(239, 68, 68, 0.2)',
            border: 'none',
            color: '#ef4444',
            padding: '4px 10px',
            borderRadius: 6,
            cursor: 'pointer',
            fontSize: '0.75rem'
          }}
          data-testid="clear-sea-results"
        >
          Clear
        </button>
      </div>
      
      {/* Ultra-compact result rows - capped at 30, scrollable */}
      <div style={{ 
        maxHeight: 320, 
        overflowY: 'auto',
        display: 'flex',
        flexDirection: 'column',
        gap: 2
      }}>
        {searchEngineResults.slice(0, 30).map((result, idx) => (
          <SearchEngineResultRow
            key={result.id || idx}
            result={result}
            token={token}
            showToast={showToast}
          />
        ))}
        {searchEngineResults.length > 30 && (
          <p style={{ color: '#71717a', fontSize: '0.7rem', textAlign: 'center', padding: 8 }}>
            Showing 30 of {searchEngineResults.length} results
          </p>
        )}
      </div>
    </div>
  );
};

export default SearchEngineResultsPanel;
